import {
  ACTIVEACC_REQUESTING,
  } from './constants'
  
export const activeAccRequest = function activeAccRequest (formData) {
  return {
    type: ACTIVEACC_REQUESTING,
    formData,
  }
}
  
export default activeAccRequest


// WEBPACK FOOTER //
// ./src/views/Pages/ActiveAcc/actions.js